var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInfoIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_443_8042)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.43734 6.41666C7.43734 6.17503 7.24146 5.97916 6.99984 5.97916C6.75821 5.97916 6.56234 6.17503 6.56234 6.41666V9.91666C6.56234 10.1583 6.75821 10.3542 6.99984 10.3542C7.24146 10.3542 7.43734 10.1583 7.43734 9.91666V6.41666Z",
    fill: "#4D5F6E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99984 0.729156C3.53655 0.729156 0.729004 3.5367 0.729004 6.99999C0.729004 10.4633 3.53655 13.2708 6.99984 13.2708C10.4631 13.2708 13.2707 10.4633 13.2707 6.99999C13.2707 3.5367 10.4631 0.729156 6.99984 0.729156ZM1.604 6.99999C1.604 4.01995 4.0198 1.60416 6.99984 1.60416C9.97987 1.60416 12.3957 4.01995 12.3957 6.99999C12.3957 9.98003 9.97987 12.3958 6.99984 12.3958C4.0198 12.3958 1.604 9.98003 1.604 6.99999Z",
    fill: "#4D5F6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.58317 4.66666C7.58317 4.98882 7.322 5.24999 6.99984 5.24999C6.67767 5.24999 6.4165 4.98882 6.4165 4.66666C6.4165 4.34449 6.67767 4.08332 6.99984 4.08332C7.322 4.08332 7.58317 4.34449 7.58317 4.66666Z",
    fill: "#4D5F6E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_443_8042"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgInfoIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/InfoIcon.142a3e951511033d314aa330d877de5e.svg";